<template>
	<div class="sidebar">
		<EncartLaFormation />
		<EncartVotreFormation />
		<EncartFacebook v-if="false" />
	</div>
</template>

<script>
import EncartLaFormation from '@components/sidebar/EncartLaFormation';
import EncartVotreFormation from '@components/sidebar/EncartVotreFormation';
import EncartFacebook from '@components/sidebar/EncartFacebook';
/**
 * Composant permettant d'afficher la sidebar du blog GRETA PDL
 *
 * @version 1.0.0
 */
export default {
	name: 'Sidebar',
	props: {},
	data() {
		return {};
	},
	mounted() {},
	methods: {},
	components: {
		EncartLaFormation,
		EncartVotreFormation,
		EncartFacebook,
	},
};
</script>

<style lang="scss" scoped>
.sidebar {
	width: 100%;

	div + div {
		margin-top: 20px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/Sidebar.vue